import React from "react";
import { useDispatch } from "react-redux";
import { userLogout } from "../state-management/actions/auth-actions";
import * as Icons from "../assets/SVGs/index";
import { isLogin } from "../state-management/actions/global-state-actions";

import Button from "./basicComponents/button";
import Cookies from "js-cookie";

interface LogoutButtonProps {
  isCollapsed: boolean; // Receive collapsed state from Sidebar
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ isCollapsed }) => {
  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      dispatch(isLogin(false));
      await userLogout()(dispatch);
      Cookies.remove("token");
      Cookies.remove("refreshToken");
    } catch (error: any) {
      console.log(error);
    }
  };

  return (
    <div className="w-full flex justify-start">
      <Button
        title={isCollapsed ? "" : "خروج از حساب "}
        onClick={handleLogout}
        icon={<Icons.LogoutIcon className="ml-2" />}
        paddingx="0px"
        paddingy="0px"
      />
    </div>
  );
};

export default LogoutButton;
